import { Component, EventEmitter, Input, Output } from '@angular/core'
import { HierarchicalMenuItem } from 'instantsearch.js/es/connectors/hierarchical-menu/connectHierarchicalMenu'

@Component({
    selector: 'app-categories-refinement-list-contents',
    templateUrl: './categories-refinement-list-contents.component.html',
    styleUrls: ['./categories-refinement-list-contents.component.scss'],
})
export class CategoriesRefinementListContentsComponent {

    @Input()
    public items: HierarchicalMenuItem[] = []

    @Output()
    public refine = new EventEmitter<string>()

    public checkIfChecked(item: HierarchicalMenuItem): void {
        if (item.isRefined) {
            item.isRefined = false
        }
    }
}
